/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_3_PInputs */

const en_cp_cmp_3_p = /** @type {(inputs: Cp_Cmp_3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDG on Campus · Claude Builder Club · OpenAI Student Collective`)
};

const id_cp_cmp_3_p = /** @type {(inputs: Cp_Cmp_3_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDG on Campus · Claude Builder Club · OpenAI Student Collective`)
};

/**
* | output |
* | --- |
* | "GDG on Campus · Claude Builder Club · OpenAI Student Collective" |
*
* @param {Cp_Cmp_3_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_3_p = /** @type {((inputs?: Cp_Cmp_3_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_3_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_3_p(inputs)
	return en_cp_cmp_3_p(inputs)
});